import { TRANSFERS } from "../actions/types";

const initalState = { resolve: ""};
const saversReducer = (state = initalState, action) => {
    switch (action.type) {
        case TRANSFERS.RESOLVE_ACCOUNT_NUMBER_SUCCESS:
           return {...state, resolve: action.payload}
          
        default:
            return state
    }
}

export default saversReducer